import { companyName } from "../../config";

export const imageTypeOneBannerData = {
  imageSection: {
    folderName: "services/Web",
    imageName: "reactjs.png",
    imageText2:
      "Converting your colossal web development vision into a sure reality with stead-fast ReactJS services!",
    imageText3:
      "NO MATTER WHAT INDUSTRY OR BUSINESS NICHE YOU COME FROM, kdr ALLOWS YOU AND YOUR IDEA TO TEAM-UP WITH FINEST OF REACTJS RESOURCES TO HELP YOU GRAB THE BEST OUT OF THE TECHNOLOGY.",
    buttonDetails: {
      buttonType: "button",
      buttonLink: "request-quote",
      buttonText: "Let's connect",
    },
  },
};

export const stackUsedData = {
  stackData: [
    {
      name: "Early adopters",
      logo: `${companyName}-Reactjs-EA`,
      heading: "Early adopters",
      description:
        "We are working on ReactJS since its inception. Being the early adopters, we provide the advantage of perfection to our clients.",
    },
    {
      name: "Methodologies",
      logo: `${companyName}-Reactjs-PM`,
      heading: "Proven methodologies",
      description:
        "With the right strategy, creativity and proven concepts based on proven methodologies, our programmers have delivered successful ReactJS projects to clients worldwide. ",
    },
    {
      name: "Experience",
      logo: `${companyName}-Reactjs-BBE`,
      heading: "Backed by experience",
      description:
        "Along with expertise, all the projects we develop are backed by an collective experience of over 50+ years in the industry.",
    },
    {
      name: "RDS",
      logo: `${companyName}-Reactjs-RDS`,
      heading: "Reliable development support",
      description:
        "Be it a solution of any size or scope, our team is always ready to answer your queries and requests at your will and wish.",
    },
    {
      name: "Architecture",
      logo: `${companyName}-Reactjs-MA`,
      heading: "Modern architecture",
      description:
        "Our development methodology and product strategy are based on advanced process architecture powered by state-of-the-art production facility.",
    },
    {
      name: "Standards",
      logo: `${companyName}-Reactjs-ATQS`,
      heading: "Adherence to quality standards",
      description:
        "Be it any development requirement or application idea you put up with, we never compromise on our quality standards.",
    },
  ],
};

export const typeThreeBannerData = {
  heading: "Why ReactJS for Web Application development",
  description:
    "CREATE INTERACTIVE USER INTERFACES WITH TIRELESS EFFORT AND SIMPLICITY",
  details: [
    {
      label: "Better User Experience",
      iconName: `${companyName}-Reactjs-BUE`,
      content:
        "Virtual DOM (Document Object Model) in ReactJS makes user experience better and developer’s work faster.",
    },
    {
      label: "A Big Timesaver",
      iconName: `${companyName}-Reactjs-ABT`,
      content:
        "Reusing codes in the form of consolidated components makes it really easy and less time-taking to get results.",
    },
    {
      label: "Easy-to-Understand",
      iconName: `${companyName}-Reactjs-ETU`,
      content:
        "As it renders code-packed components without you having to trace the program flow, it becomes quite easy to work with ReactJS.",
    },
    {
      label: "Great Developer Tools",
      iconName: `${companyName}-Reactjs-GDT`,
      content:
        "ReactJS comes with tools that allow you to establish and track hierarchies of components besides allowing you to use resourceful design and debugging options.",
    },
    {
      label: "Easy to Write With JSX",
      iconName: `${companyName}-Reactjs-ETWWJ`,
      content:
        "Going with ReactJS web development it gets easy to work on JSX, which allows you to add bits of HTML to your JavaScript code allowing you to work with simple and neat codes.",
    },
    {
      label: "Performance Leveraging Ecosystem",
      iconName: `${companyName}-Reactjs-PLE`,
      content:
        "It puts up with a complete ecosystem of training content, support resources, coding guidelines, discussion forums – making you learn and apply better.",
    },
  ],
};

export const typeNineBannerData = {
  heading: "What makes ReactJS such a pacesetter for businesses",
  description:
    "TRENDIEST FRAMEWORK TO BUILD AWESOME APP WITHIN BUDGET AND TIMING",
  para1:
    "ReactJS is essentially an open source JavaScript library that brings together finely curated code components to allow users to have a quick and easy way to build HTML websites. As developers get to refer, access, and apply optimally arranged and validated set of codes, it proves to be highly supportive and perceptive to go with ReactJS web development. Further, a constant and engrossing contribution by a large pool of developers and technology companies makes it an ever more prolific, dependable and user-friendly source of code crunching. Which is also the reason ReactJS unceasingly grows big and vast in terms of scope and prospects of application and development.",
  para2:
    "At the top of all, the regular source upgrades and optimization of ReactJS as a development repository makes it ever disruptive and resourceful as an HTML scripting platform. Which makes it expand further, with more development options and resources joining in, to become highly popular as a development platform.",
};

export const multiRowData = {
  text1: "LEVERAGE MOST CREDIBLE REACTJS DEVELOPERS",
  text2: "Hire ReactJS developer and avail best value for your project",
  text3:
    "As a seasoned ReactJS development company, kdr is trusted for quality ReactJS development services by businesses and operators from all over the world. Our flexible resource hiring model offers you the most valuable results by allowing you highly customized and purpose-focused development options. While offering you hiring services, we make sure you get the right fit of skills and capabilities in the ReactJS developer you choose to work with. Going with our services you assure yourself of standardized methods, streamlined processes, and agile practices, offering you the best possible results in a highly cost-effective manner. And we do this neatly by perceptively aligning and serving your ReactJS web development needs with best-fitting development factors, well-supporting knowledge resources and the right professionals efficiently delivering all that is needed.",
  carouselData: [
    {
      iconName: `${companyName}-Reactjs-IUD`,
      label: "Interactive UI development",
    },
    {
      iconName: `${companyName}-Reactjs-CD`,
      label: "Custom Development",
    },
    {
      iconName: `${companyName}-Reactjs-AD`,
      label: "AJAX Development",
    },
    {
      iconName: `${companyName}-Reactjs-ECD`,
      label: "eCommerce Development",
    },
    {
      iconName: `${companyName}-Reactjs-RM`,
      label: "ReactJS Migration",
    },
    {
      iconName: `${companyName}-Reactjs-PID`,
      label: "Plug-In Development",
    },
  ],
  buttonLink: "#workWithUs",
  buttonText: "hire ReactJs Developers",
};

export const typeFourBannerData = {
  heading: "Why choose kdr for your next ReactJS Project?",
  text1:
    "kdr is one of the pioneer development houses in the domain of IT, that absorbs latest technologies and premium methods of development, as and when they come. For us working on ReactJS comes fine with our adept team of HTML developers who are well-equipped with skills and resources to bring the best out of the React technology. We closely follow ReactJS as it steadily and compellingly finds better slots and is increasingly used as one of the most inventive and forward-looking web technologies. Which makes us all tuned-up and ready to serve you with advanced ReactJS development services in your realm of utility and benefits with latest technology-wide offerings!",
  description:
    "DAZZLINGLY SKILLED DEVELOPERS WHO HANDLE TECHNICALITIES WITH EASE",
};
